/* import __COLOCATED_TEMPLATE__ from './status.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();